// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 21/08/2025

import EndOfDayActionTypes from './end-of-day.types';

/** ***************** GET ALL COLLECTION DETAILS START *********************** */
export const getAllCollectionDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getAllCollectionDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getAllCollectionDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getAllCollectionDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getAllCollectionDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ALL COLLECTION DETAILS END *********************** */

/** ***************** GET BRANCH EOD WALLET DETAILS START *********************** */
export const getBranchEODWalletDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_START,
	payload: getData,
});

export const getBranchEODWalletDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchEODWalletDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_FAILURE,
	payload: failureData,
});

export const getBranchEODWalletDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_RESPONSE_RESET,
});

export const getBranchEODWalletDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH EOD WALLET DETAILS END *********************** */

/** ***************** GET BRANCH EOD THRIFT DETAILS START *********************** */
export const getBranchEODThriftDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_START,
	payload: getData,
});

export const getBranchEODThriftDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchEODThriftDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_FAILURE,
	payload: failureData,
});

export const getBranchEODThriftDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_RESPONSE_RESET,
});

export const getBranchEODThriftDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH EOD THRIFT DETAILS END *********************** */

/** ***************** GET BRANCH EOD SAVINGS DETAILS START *********************** */
export const getBranchEODSavingsDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_START,
	payload: getData,
});

export const getBranchEODSavingsDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchEODSavingsDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_FAILURE,
	payload: failureData,
});

export const getBranchEODSavingsDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_RESPONSE_RESET,
});

export const getBranchEODSavingsDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH EOD SAVINGS DETAILS END *********************** */

/** ***************** GET BRANCH EOD YETTOCOLLECT ARREAR DETAILS START *********************** */
export const getBranchEODYetToCollectArrearDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_START,
	payload: getData,
});

export const getBranchEODYetToCollectArrearDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchEODYetToCollectArrearDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_FAILURE,
	payload: failureData,
});

export const getBranchEODYetToCollectArrearDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_RESPONSE_RESET,
});

export const getBranchEODYetToCollectArrearDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH EOD FIXED DEPOSIT DETAILS END *********************** */

/** ***************** GET ACCOUNT DAY BOOK REPORT START *********************** */
export const fetchAccountDayBookReportStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_START,
	payload: getData,
});

export const fetchAccountDayBookReportSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_SUCCESS,
	payload: successData,
});

export const fetchAccountDayBookReportFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_FAILURE,
	payload: failureData,
});

export const fetchAccountDayBookReportResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
});

export const fetchAccountDayBookReportResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET ACCOUNT DAY BOOK REPORT END *********************** */

/** ***************** GET DEMAND COLLECTION TOTAL DETAILS START *********************** */
export const getDemandCollectionTotalDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_START,
	payload: getData,
});

export const getDemandCollectionTotalDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_SUCCESS,
	payload: successData,
});

export const getDemandCollectionTotalDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_FAILURE,
	payload: failureData,
});

export const getDemandCollectionTotalDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
});

export const getDemandCollectionTotalDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET Demand COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET ADVANCE COLLECTION TOTAL DETAILS START *********************** */
export const getAdvanceCollectionTotalDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_START,
	payload: getData,
});

export const getAdvanceCollectionTotalDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_SUCCESS,
	payload: successData,
});

export const getAdvanceCollectionTotalDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_FAILURE,
	payload: failureData,
});

export const getAdvanceCollectionTotalDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
});

export const getAdvanceCollectionTotalDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ADVANCE COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET ARREAR COLLECTION TOTAL DETAILS START *********************** */
export const getArrearCollectionTotalDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_START,
	payload: getData,
});

export const getArrearCollectionTotalDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_SUCCESS,
	payload: successData,
});

export const getArrearCollectionTotalDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_FAILURE,
	payload: failureData,
});

export const getArrearCollectionTotalDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
});

export const getArrearCollectionTotalDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ARREAR COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET WALLET COLLECTION TOTAL DETAILS START *********************** */
export const getWalletCollectionTotalDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_START,
	payload: getData,
});

export const getWalletCollectionTotalDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_SUCCESS,
	payload: successData,
});

export const getWalletCollectionTotalDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_FAILURE,
	payload: failureData,
});

export const getWalletCollectionTotalDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
});

export const getWalletCollectionTotalDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET WALLET COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET PRECLOSE COLLECTION TOTAL DETAILS START *********************** */
export const getPrecloseCollectionTotalDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_START,
	payload: getData,
});

export const getPrecloseCollectionTotalDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_SUCCESS,
	payload: successData,
});

export const getPrecloseCollectionTotalDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_FAILURE,
	payload: failureData,
});

export const getPrecloseCollectionTotalDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
});

export const getPrecloseCollectionTotalDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET PRECLOSE COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET LOAN ADVANCE USED TOTAL DETAILS START *********************** */
export const getLoanAdvanceUsedTotalDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_START,
	payload: getData,
});

export const getLoanAdvanceUsedTotalDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_SUCCESS,
	payload: successData,
});

export const getLoanAdvanceUsedTotalDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_FAILURE,
	payload: failureData,
});

export const getLoanAdvanceUsedTotalDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_RESPONSE_RESET,
});

export const getLoanAdvanceUsedTotalDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET LOAN ADVANCE USED TOTAL DETAILS END *********************** */

/** ***************** GET CLOSE LOAN LIST DETAILS START *********************** */
export const getCloseLoanListDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_START,
	payload: getData,
});

export const getCloseLoanListDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_SUCCESS,
	payload: successData,
});

export const getCloseLoanListDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_FAILURE,
	payload: failureData,
});

export const getCloseLoanListDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_RESPONSE_RESET,
});

export const getCloseLoanListDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET CLOSE_LOAN_LIST DETAILS END *********************** */

/** ***************** GET BRANCH EOD DETAILS START *********************** */
export const getBranchEODDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_START,
	payload: getData,
});

export const getBranchEODDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchEODDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_FAILURE,
	payload: failureData,
});

export const getBranchEODDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_RESPONSE_RESET,
});

export const getBranchEODDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET Branch EOD DETAILS END *********************** */

/** ***************** GET PREVIOUS DAY BANK ACCOUNT DAY BOOK REPORT START *********************** */
export const fetchPreviousDayBankAccountDayBookReportStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_START,
	payload: getData,
});

export const getPreviousDayBankAccountDayBookReportSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_SUCCESS,
	payload: successData,
});

export const getPreviousDayBankAccountDayBookReportFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_FAILURE,
	payload: failureData,
});

export const fetchPreviousDayBankAccountDayBookReportResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
});

export const getPreviousDayBankAccountDayBookReportResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET PREVIOUS DAY BANK ACCOUNT DAY BOOK REPORT END *********************** */

/** ***************** GET BANK ACCOUNT DAY BOOK REPORT START *********************** */
export const fetchBankAccountDayBookReportStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_START,
	payload: getData,
});

export const fetchBankAccountDayBookReportSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_SUCCESS,
	payload: successData,
});

export const fetchBankAccountDayBookReportFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_FAILURE,
	payload: failureData,
});

export const fetchBankAccountDayBookReportResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
});

export const fetchBankAccountDayBookReportResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET BANK ACCOUNT DAY BOOK REPORT END *********************** */

/** ***************** GET PREVIOUS DAY CASH ACCOUNT DAY BOOK REPORT START *********************** */
export const fetchPreviousDayCashAccountDayBookReportStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_START,
	payload: getData,
});

export const getPreviousDayCashAccountDayBookReportSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_SUCCESS,
	payload: successData,
});

export const getPreviousDayCashAccountDayBookReportFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_FAILURE,
	payload: failureData,
});

export const fetchPreviousDayCashAccountDayBookReportResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
});

export const getPreviousDayCashAccountDayBookReportResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET PREVIOUS DAY CASH ACCOUNT DAY BOOK REPORT END *********************** */

/** ***************** GET CASH ACCOUNT DAY BOOK REPORT START *********************** */
export const fetchCashAccountDayBookReportStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_START,
	payload: getData,
});

export const getCashAccountDayBookReportSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_SUCCESS,
	payload: successData,
});

export const getCashAccountDayBookReportFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_FAILURE,
	payload: failureData,
});

export const fetchCashAccountDayBookReportResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
});

export const getCashAccountDayBookReportResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET CASH ACCOUNT DAY BOOK REPORT END *********************** */

/** ***************** GET PRECLOSE COLLECTION DETAILS START *********************** */
export const getPrecloseCollectionDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getPrecloseCollectionDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getPrecloseCollectionDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getPrecloseCollectionDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getPrecloseCollectionDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET PRECLOSE COLLECTION DETAILS END *********************** */

/** ***************** GET ADVANCE COLLECTION DETAILS START *********************** */
export const getAdvanceCollectionDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getAdvanceCollectionDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getAdvanceCollectionDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getAdvanceCollectionDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getAdvanceCollectionDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ADVANCE COLLECTION DETAILS END *********************** */

/** ***************** GET ARREAR COLLECTION DETAILS START *********************** */
export const getArrearCollectionDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getArrearCollectionDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getArrearCollectionDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getArrearCollectionDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getArrearCollectionDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ARREAR COLLECTION DETAILS END *********************** */

/** ***************** GET VOUCHER APPROVED DETAILS START *********************** */
export const getVoucherApprovedDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_START,
	payload: getData,
});

export const getVoucherApprovedDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_SUCCESS,
	payload: successData,
});

export const getVoucherApprovedDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_FAILURE,
	payload: failureData,
});

export const getVoucherApprovedDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_RESPONSE_RESET,
});

export const getVoucherApprovedDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET VOUCHER_APPROVED DETAILS END *********************** */

/** ***************** SUBMIT EOD DETAILS START *********************** */
export const getSubmitEODDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_START,
	payload: getData,
});

export const getSubmitEODDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_SUCCESS,
	payload: successData,
});

export const getSubmitEODDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_FAILURE,
	payload: failureData,
});

export const getSubmitEODDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_RESPONSE_RESET,
});

export const getSubmitEODDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET SUBMIT EOD DETAILS END *********************** */

/** ***************** REVERT EOD DETAILS START *********************** */
export const getRevertEODDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_START,
	payload: getData,
});

export const getRevertEODDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_SUCCESS,
	payload: successData,
});

export const getRevertEODDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_FAILURE,
	payload: failureData,
});

export const getRevertEODDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_RESPONSE_RESET,
});

export const getRevertEODDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET REVERT EOD DETAILS END *********************** */

/** ***************** GET EOD SAVINGS COLLECTION DETAILS START *********************** */
export const getEODSavingsCollectionDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getEODSavingsCollectionDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getEODSavingsCollectionDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getEODSavingsCollectionDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getEODSavingsCollectionDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET EOD SAVINGS COLLECTION DETAILS END *********************** */

/** ***************** GET EOD GOLD COLLECTION DETAILS START *********************** */
export const getEODGoldCollectionDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getEODGoldCollectionDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getEODGoldCollectionDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getEODGoldCollectionDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getEODGoldCollectionDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET EOD GOLD COLLECTION DETAILS END *********************** */

/** ***************** GET EOD STAFF TRAVEL DETAILS START *********************** */
export const getEODStaffTravelDetailsStart = (getData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_START,
	payload: getData,
});

export const getEODStaffTravelDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_SUCCESS,
	payload: successData,
});

export const getEODStaffTravelDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_FAILURE,
	payload: failureData,
});

export const getEODStaffTravelDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
});

export const getEODStaffTravelDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET EOD STAFF TRAVEL DETAILS END *********************** */

/** ***************** SUBMIT EOD STAFF TRAVEL DETAILS START *********************** */
export const submitEODStaffTravelDetailsStart = (postData: any) => ({
	type: EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_START,
	payload: postData,
});

export const submitEODStaffTravelDetailsSuccess = (successData: any) => ({
	type: EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_SUCCESS,
	payload: successData,
});

export const submitEODStaffTravelDetailsFailure = (failureData: any) => ({
	type: EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_FAILURE,
	payload: failureData,
});

export const submitEODStaffTravelDetailsResponseResetStart = () => ({
	type: EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
});

export const submitEODStaffTravelDetailsResponseChanged = () => ({
	type: EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** SUBMIT EOD STAFF TRAVEL DETAILS END *********************** */
